module.exports = __webpack_public_path__ + "img/13.aaebd091.gif";